
define(
	'C3.ShoppingExtensions.InventoryList'
,   [
		'C3.ShoppingExtensions.InventoryList.View'
	]
,   function (
		InventoryListView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			// using the 'Layout' component we add a new child view inside the 'Header' existing view 
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html
			
			/** @type {LayoutComponent} */
			var layout = container.getComponent('Layout');
			var pageTypeComponent = container.getComponent("PageType");
			
			if(layout)
			{
				var InventoryListPageType = {
				    name: 'inventorylistpage',
				    routes : ['inventory-list'],
				    view: InventoryListView,
				    defaultTemplate: {
				        name: 'c3_shoppingextensions_inventorylist.tpl',
				        displayName: 'Inventory List Page'
				    }
				}

				pageTypeComponent.registerPageType(InventoryListPageType);
			}

		}
	};
});
